import { FC } from 'react';
import { BasicDialog } from '../../../../../components/Dialog/BasicDialog';
import { MilestoneForm, MilestoneInitialValues } from './MilestoneForm';

interface MilestoneModalProps {
  open: boolean;
  onClose: () => void;
  initialValues?: MilestoneInitialValues;
}
export const MilestoneModal: FC<MilestoneModalProps> = ({ onClose, open, initialValues }) => {
  return (
    <BasicDialog
      title={`${typeof initialValues?.id === 'number' ? 'Edit' : 'Add'} Milestone`}
      open={open}
      onClose={onClose}
    >
      <MilestoneForm onClose={onClose} initialValues={initialValues} />
    </BasicDialog>
  );
};
